function Topic(){
    return(
         <div class="topics">
        <h1 class="topics__title">Topics recommended for you</h1>
        <div class="topics__container">
            <p>Website</p>
            <p>JavaScript</p>
            <p>CSS</p>
            <p>Mongo DB</p>
            <p>Azure</p>
            <p>AWS</p>
            <p>Docker</p>
            <p>GitHuB</p>
            <p>React JS</p>
        </div>
    </div>

    )
}

export default Topic